<template>
<!-- 地块所属城区选择控件 -->
    <el-popover
        placement="bottom-start"
        transition="el-zoom-in-top"
        trigger="click"
        v-model="visible"
        popper-class="areaSelect-popper">
        <div class="popperMain">
            <SelectBySearch
                v-for="(item,index) in seletList"
                :key="index"
                v-if="item.data && item.data.length"
                :options="item.data"
                :activeItem="item.activeItem"
                :placeholder="item.placeholder"
                :hasCheckAll="hasCheckAll"
                @clickItem="item=>clickItem(item,index)"
                @valueChange="valueChange"
            />
        </div>
        <!-- 显示框 -->
        <slot name="selectTitle" slot="reference">
            <div class="cityValue-ipt-wrap">
                <el-input
                    :placeholder="placeholderWrap"
                    class="citySearch cityValue-ipt-areaSelect"
                    readonly
                    :value="firstShowValue">
                    <i
                        v-if="firstShowValue"
                        slot="suffix"
                        :class="['el-icon-caret-bottom',{'icon_up_amt':visible,'icon_down_amt':!visible, 'clearBtn':firstShowValue}]"
                        @click.stop="clearAll">
                    </i>
                    <i
                        v-else
                        slot="suffix"
                        :class="['el-icon-caret-bottom','cursor_pointer',{'icon_up_amt':visible,'icon_down_amt':!visible}]"
                        >
                    </i>
                </el-input>
                <div class="cityValue-ipt-areaSelect-tag" v-if="firstShowValue">
                    <!-- <div class="tag">{{firstShowValue}} <i class="el-icon-error closeIcon" @click.stop="delFirstItem"></i></div> -->
                    <div class="tag noClose">{{firstShowValue}}</div>
                    <div class="tag num" v-if="allCheckNum > 1">+{{allCheckNum - 1}}</div>
                </div>
            </div>
        </slot>
    </el-popover>
</template>

<script>
import SelectBySearch from './SelectBySearch'
export default {
    name:'MultipleSelectDiy',
    components:{
        SelectBySearch
    },
    props:{
        placeholderWrap:{
            default:''
        },
        // 选项列表
        options:{
            type:Array,
            default:()=>[]
        },
        placeholderData:{
            default:()=>[]
        },
        // 默认值
        defaultVal:{
            default:()=>[]
        },
        hasCheckAll:{
            default:false
        },
    },
    data() {
        return {
            visible: false,// 控制下拉显示/隐藏
            seletList:[],
        }
    },
    computed:{
        allCheckNum(){
            return this.getAllCheckNum(this.defaultVal)
        },
        firstShowValue(){//占位值，用来触发clearable按钮显示
            return this.getFirstVal(this.defaultVal)
        }
    },
    watch:{
        options:{
            handler(newVal,oldVal){
                // 首次加载时触发
                if(oldVal.length == 0 && newVal.length != 0){
                    console.log(11);
                    this.initSelectList()
                }
            },
            deep:true
        }
    },
    created(){
        this.initSelectList()
    },
    methods: {
        initSelectList(){
            this.seletList = []
            this.placeholderData.forEach((item,index)=>{
                let obj = {
                    placeholder:item,
                    data:[],
                    activeItem:'',
                }
                if(index==0){
                    obj.data = this.options
                }
                this.seletList.push(obj)
            })
            console.log(this.seletList);
        },
        clickItem(item,index){
            let len = this.placeholderData.length - 1;
            this.seletList[index].activeItem = item.sName
            for(var i = index + 1; i < len + 1; i++){
                this.seletList[i].data = []
                this.seletList[i].activeItem = ''
            }
            if(index < len){
                this.seletList[index + 1].data = item.aChildren
            }
            console.log(this.seletList);
        },
        valueChange(){
            this.$emit("valueChange");
        },
        // 通过选项数组获取第一组值
        getFirstVal(data = []){
            console.log(data);
            let val = ''
            if(data.length){
                let item = data[0]
                val = item.sName
                if(item.aChildren && item.aChildren.length){
                    val += ('/' + this.getFirstVal(item.aChildren))
                }
            }
            return val
        },
        getAllCheckNum(data = []){
            let n = 0
            if(data.length){
               data.forEach(item=>{
                   if(item.aChildren){
                       n += this.getAllCheckNum(item.aChildren)
                   }else{
                       n += 1
                   }
               })
            };
            return n
        },
        clearAll(){
            this.$emit("clearAll");
        },
        delFirstItem(){
            this.$emit("delFirstItem",this.firstShowValue);
        }
    },

}
</script>

<style lang="scss" scoped>
.cityValue-ipt-wrap{
    position: relative;
}
.select-ipt{
    width: 85%;
    border: 1px solid #EEEEEE;
    padding: 0 0.1rem 0 0.15rem;
    height: 0.36rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.18rem;
    outline: none;
    i{
        color: #C0C4CC;
    }
}
.popperMain{
    display: flex;
    min-height: 2rem;
}
</style>
